<template>
  <div class="ip-matches-panel custom-scroll">
    <div class="ip-matches-panel__title">
      <div class="ip-matches-panel__title-text">
        Совпадения по IP
      </div>
    </div>

    <p-pagination
      v-if="pageCount > 1"
      v-model="currentPage"
      class="table__pagination"
      type="info"
      :page-count="pageCount"/>

    <div class="ip-matches-panel__table custom-scroll">
      <el-table
        v-loading="loading"
        :border="false"
        :data="ipMatches"
        element-loading-background="rgba(255, 255, 255, 0.6)"
        :empty-text="loading ? 'Обновление данных...' : 'Совпадения не найдены'"
        header-cell-class-name="table__header-cell"
        cell-class-name="table__row-cell user-table__row-cell">
        <el-table-column
          label="IP"
          property="id"
          :width="ipColumn ? ipColumn : 120"
          align="center"/>
        <el-table-column
          label="Число совпадений"
          property="count"
          :width="overlapColumn? overlapColumn : 130"
          align="center"/>
        <el-table-column :width="btnColumn ? btnColumn : 74" align="center">
          <template #default="props">
            <p-button
              icon
              round
              size="sm"
              class="search-btn"
              @click="() => handleClickSearchBtn(props.row.id)">
              <i class="fa fa-search"/>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {Pagination} from 'src/components/UIComponents'
import { mapMutations, mapGetters } from "vuex"

export default {
  name: "IpMatchesPanel",
  components: {
    [Pagination.name]: Pagination,
  },
  inject: ["mq"],
  data() {
    return {
      currentPage: 1,
      pageCount: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['ipMatches', 'ipMatchesPageCount']),
    ipColumn() {
      return {
        xs: 110
      }[this.mq.current]
    },
    overlapColumn() {
      return {
        xs: 100
      }[this.mq.current]
    },
    btnColumn() {
      return {
        xs: 50
      }[this.mq.current]
    },
  },
  watch: {
    async currentPage() {
      await this.updateMatchesList()
    },
  },
  methods: {
    ...mapMutations(['setListSearch']),
    async updateMatchesList() {
      this.loading = true
      try {
        await this.$store.dispatch('loadIpMatches', {
          page: this.currentPage,
        })
        this.pageCount = this.ipMatchesPageCount
      } finally {
        this.loading = false
      }
    },
    handleClickSearchBtn(ip) {
      this.setListSearch(ip)
    }
  },
  async beforeMount() {
    await this.updateMatchesList()
  },
  beforeUnmount() {
    this.$store.dispatch('clearIpMatches')
  }
}
</script>

<style scoped>

</style>
